export const CONFIRMED_GET_TOKEN_MULTI_LIST = "CONFIRMED_GET_TOKEN_MULTI_LIST"
export const SET_PAUSED_DOCTOR_ID = "SET_PAUSED_DOCTOR_ID" // New action type
